import { CdkService, UpdateIdentificationVehicleRequest, VehicleIdentification } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export type UpdateVehicleIdentificationInput = {
  branchId: number;
  vehicleId: string;
  identification: VehicleIdentification;
};

const CDK_AUDIT_DATA = {
  userId: 'api-1588',
  userName: 'QS API'
};

export const useUpdateVehicleIdentificationMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CdkService.postCdkVehiclesVehicleUpdateIdentification>>,
      QueryError,
      UpdateVehicleIdentificationInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: UpdateVehicleIdentificationInput) => {
    const requestBody: UpdateIdentificationVehicleRequest = {
      metadata: {
        auditData: CDK_AUDIT_DATA
      },
      identification: input.identification
    };
    return CdkService.postCdkVehiclesVehicleUpdateIdentification(input.branchId, input.vehicleId, requestBody);
  }, options);
